/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { confirmDialog } from '@/components/dialog';
import router from '@/router';
import request, { AxiosRequestConfig, RequestBizError } from '@hb/sharp-request';
import { ubtPageButtonNew, ubtSendError } from '../ubt';

/** 当前时间-网络异常-确认框是否已处于打开状态 */
let retryDialogOpenInstance: null | Promise<unknown> = null;
/** 待重试请求config队列 */
const waitRetryRequestQueue: AxiosRequestConfig[] = [];
/** 各个接口重试请求的axios实例 */
const retryRequestInstance: { [key: string]: Promise<unknown> | null } = {};
/** 是否已监听路由变化 */
let hasListenRouterChanged = false;

/** 监听用户退出页面后，清空缓存 */
export const addListenRouterChange = () => {
  if (!hasListenRouterChanged) {
    hasListenRouterChanged = true;

    /** 当路由发生变化后，说明已退出当前异常页，则清空缓存数据 & 关闭弹窗 */
    router.afterEach(() => {
      retryDialogOpenInstance = null;
      waitRetryRequestQueue.splice(0);
      /** 清空重试请求的实例 */
      Object.keys(retryRequestInstance).forEach((id) => {
        delete retryRequestInstance[id];
      });
      /** 关闭弹窗，若用户未点击刷新就退出页面 */
      confirmDialog.close();
    });
  }
};

/** 网络接口异常确认框，支持重新请求 */
export const requestRetryDialog = (config: AxiosRequestConfig) => {
  /** 若已有接口先打开“重试”弹窗，则不再重复打开 */
  if (!retryDialogOpenInstance) {
    const { pageId } = (router.currentRoute?.meta || {}) as { pageId: string };

    retryDialogOpenInstance = confirmDialog.open({
      title: '网络异常',
      content: '您可尝试刷新页面',
      confirmText: '立即刷新',
      confirmBtnStyle: 'font-size: 16px',
      cancelBtnStyle: 'font-size: 16px',
      showCloseIcon: false,
    }).then(() => {
      if (waitRetryRequestQueue.length) {
        waitRetryRequestQueue.forEach((item) => {
          const { transitionId, baseURL } = item;
          if (baseURL && transitionId) {
            retryRequestInstance[transitionId] = request.post(baseURL, item.data, item);
          } else {
            ubtSendError(new Error('retry request get url or transitionId failed'));
          }
        });
      }

      retryDialogOpenInstance = null;
      waitRetryRequestQueue.splice(0);

      ubtPageButtonNew(pageId, 'finance_request_error_retry_dialog_confirm', {});
    });

    ubtPageButtonNew(pageId, 'finance_request_error_retry_dialog', {});
  }

  waitRetryRequestQueue.push(config);
  addListenRouterChange();
};

/** 当前transitionId是否已重试请求过le */
export const checkThisTransitionHasRetry = (config: AxiosRequestConfig) => retryRequestInstance[config.transitionId || ''];

/** 设置errorRetryDialog后，请在请求catch调用此方法进行，数据重置处理 */
export const requestRetryWrapHandler = <T>(error: RequestBizError): Promise<T> => {
  if (retryDialogOpenInstance instanceof Promise) {
    return new Promise((resolve, reject) => {
      (retryDialogOpenInstance as Promise<unknown>).then(async () => {
        const { transitionId = '' } = error;
        const retryRequestIns = retryRequestInstance[transitionId];

        if (retryRequestIns) {
          try {
            const response = await retryRequestIns;
            resolve(response as T);
          } catch (err) {
            /** 仅重试一次，若仍然失败，则中止流程 */
            reject(err);
          }
        }

        reject(error);
      });
    });
  }

  return Promise.reject(error);
};
